import React, {useState, useEffect} from 'react';
import Strings from "../Lang/strings";

const ZainBanner = () => {
        const [largeBanner, setLargeBanner] = useState();
        const [smallBanner, setSmallBanner] = useState();
        let currentLang = Strings.getLanguage();
        useEffect(() => {
            import(`../assets/images/${currentLang}-large-banner.jpeg`).then(image => {
                setLargeBanner(image);
            });
            import(`../assets/images/${currentLang}-small-banner.jpeg`).then(image => {
                setSmallBanner(image);
            });


        }, [currentLang]);
        return (
            <>{
                largeBanner && smallBanner &&
                <div className={"w-full rounded"}>
                    <img className={"hidden rounded w-full my-1.5 sm:block"} style={{height: "404px"}} id={"zain-banner"}
                         src={largeBanner.default}
                         alt="large zain banner"/>
                    <img style={{height: "280px"}} className={"sm:hidden rounded w-full"} id={"zain-banner"}
                         src={smallBanner.default}
                         alt="small zain banner"/>
                </div>
            }

            </>
        );
    }
;

export default ZainBanner;
